// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nCoo8","rootOffWhite":"styles_rootOffWhite__I831z","main":"styles_main__W2VBK"};